function coerceEnumKey<T extends string>(
  value: unknown,
  keys: readonly T[]
): T | undefined {
  if (value == null || value === '') return undefined;

  if (typeof value === 'number' && Number.isInteger(value) && value >= 0 && value < keys.length) {
    return keys[value];
  }

  if (typeof value === 'string') {
    if (keys.includes(value as T)) return value as T;
    const numeric = Number(value);
    if (Number.isInteger(numeric) && numeric >= 0 && numeric < keys.length) {
      return keys[numeric];
    }
  }

  return undefined;
}

const AGENT_TYPE_KEYS = ['AI', 'Automation', 'Hybrid'] as const;
const AGENT_STATUS_KEYS = ['Draft', 'Active', 'Paused', 'Archived'] as const;
const AGENT_FLOW_STATUS_KEYS = ['Draft', 'Active', 'Archived'] as const;
const AGENT_EXECUTION_STATUS_KEYS = [
  'Pending',
  'Running',
  'WaitingExternal',
  'Completed',
  'Failed',
  'Cancelled',
] as const;
const AGENT_TOOL_TYPE_KEYS = ['Http', 'Sql', 'Knowledge', 'Automation', 'Builtin'] as const;
const AGENT_PLATFORM_SCOPE_KEYS = ['System', 'Tenant'] as const;
const AGENT_RESOURCE_VISIBILITY_KEYS = ['Internal', 'Configurable', 'AgentTool'] as const;
const AGENT_EXECUTION_TRIGGER_KEYS = ['User', 'Schedule', 'Event', 'Agent'] as const;

export type NormalizedAgentType = (typeof AGENT_TYPE_KEYS)[number];
export type NormalizedAgentStatus = (typeof AGENT_STATUS_KEYS)[number];
export type NormalizedAgentFlowStatus = (typeof AGENT_FLOW_STATUS_KEYS)[number];
export type NormalizedAgentExecutionStatus = (typeof AGENT_EXECUTION_STATUS_KEYS)[number];
export type NormalizedAgentToolType = (typeof AGENT_TOOL_TYPE_KEYS)[number];
export type NormalizedAgentPlatformScope = (typeof AGENT_PLATFORM_SCOPE_KEYS)[number];
export type NormalizedAgentResourceVisibility = (typeof AGENT_RESOURCE_VISIBILITY_KEYS)[number];
export type NormalizedAgentExecutionTriggerType = (typeof AGENT_EXECUTION_TRIGGER_KEYS)[number];

export function normalizeAgentType(value: unknown): NormalizedAgentType {
  return coerceEnumKey(value, AGENT_TYPE_KEYS) ?? 'AI';
}

export function normalizeAgentStatus(value: unknown): NormalizedAgentStatus {
  return coerceEnumKey(value, AGENT_STATUS_KEYS) ?? 'Draft';
}

export function normalizeAgentFlowStatus(value: unknown): NormalizedAgentFlowStatus {
  return coerceEnumKey(value, AGENT_FLOW_STATUS_KEYS) ?? 'Draft';
}

export function normalizeAgentExecutionStatus(value: unknown): NormalizedAgentExecutionStatus {
  return coerceEnumKey(value, AGENT_EXECUTION_STATUS_KEYS) ?? 'Pending';
}

export function normalizeAgentToolType(value: unknown): NormalizedAgentToolType {
  return coerceEnumKey(value, AGENT_TOOL_TYPE_KEYS) ?? 'Http';
}

export function normalizeAgentPlatformScope(value: unknown): NormalizedAgentPlatformScope {
  return coerceEnumKey(value, AGENT_PLATFORM_SCOPE_KEYS) ?? 'Tenant';
}

export function normalizeAgentResourceVisibility(value: unknown): NormalizedAgentResourceVisibility {
  return coerceEnumKey(value, AGENT_RESOURCE_VISIBILITY_KEYS) ?? 'Internal';
}

export function normalizeAgentExecutionTriggerType(value: unknown): NormalizedAgentExecutionTriggerType {
  return coerceEnumKey(value, AGENT_EXECUTION_TRIGGER_KEYS) ?? 'User';
}
